// removed by extract-text-webpack-plugin
module.exports = {"component":"_2P_tvaUYNu_Vu0vpSGzuxN","link":"_3thXu8_WTughwptfgxF8LT","img":"_1PIzyDGNW8_YRLkT0jeGYM","text":"_3ZA9_6OKyufbyo32NtIuz6","shopName":"_3N7T5OvTUty39jB7YkUtia","shopAddress":"_3IXJpsqr4HA3pLONExgjyc","logo":"_3Jfv4TZsn_WlS4qj4-3QbN","workstationLogo":"aL-01IuGwtP-IYqduDncC","shopProductType":"_2Kl0NjsOHjzOx7KUGug5j7","shopInfoBefore":"_1lteH2jrUe62mYBUTb9JfN","address":"_3Wpa5QxPWO1aGFD4GMnRdR","mr0":"sqoFjl1A5UGZIcxml07o8","w418":"_2McOhLiHyOj6vRHQNqpv-s","w420":"_3eNfogl4M-ymOliWn5ZNOb"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/ExperienceShopInfo/ExperienceShopInfo.scss
 ** module id = 258
 ** module chunks = 0
 **/